<template>
    <router-view />
</template>
<script>
export default {
    beforeRouteUpdate(to, from, next) {
        if (to.name == 'agro-visita') {
            next({ name: 'agro-visita-list' });
        } else {
            next();
        }
    },
    created() {
        if (this.$route.name == 'agro-visita') {
            this.$router.push({ name: 'agro-visita-list' });
        }
    },
};
</script>
